import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const SliderLawyersCMS = () => {
  const [imageLawyers, setImageLawyers] = useState([]);
  const [textLawyers, setTextLawyers] = useState([]);
  const [newImage, setNewImage] = useState(null);
  const [newText, setNewText] = useState('');
  const [addSuccessMessage, setAddSuccessMessage] = useState('');
  const [addError, setAddError] = useState('');
  const [updateSuccessMessage, setUpdateSuccessMessage] = useState('');
  const [updateError, setUpdateError] = useState('');
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [lawyerToDelete, setLawyerToDelete] = useState(null);
  const [editingImageLawyer, setEditingImageLawyer] = useState(null);
  const [editingTextLawyer, setEditingTextLawyer] = useState(null);
  const [imageErrorUpdate, setImageErrorUpdate] = useState('');

  useEffect(() => {
    fetchLawyersImages();
    fetchLawyersTexts();
  }, []);

  const fetchLawyersImages = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/SliderLawyer/listImages');
      setImageLawyers(response.data.data);
    } catch (error) {
      console.error('Error fetching lawyer images:', error);
    }
  };

  const fetchLawyersTexts = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/SliderLawyer/listTexts');
      setTextLawyers(response.data.data);
    } catch (error) {
      console.error('Error fetching lawyer texts:', error);
    }
  };

  const addLawyerImage = async () => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.post('https://back.zubilaw.com/SliderLawyer/addImage', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setAddSuccessMessage('Lawyer image added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewImage(null);
      fetchLawyersImages();
    } catch (error) {
      setAddError('Please select an image to upload.');
      console.error('Error adding lawyer image:', error);
    }
  };

  const addLawyerText = async () => {
    const data = {
      text: newText,
    };

    try {
      await axios.post('https://back.zubilaw.com/SliderLawyer/addText', data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setAddSuccessMessage('Lawyer text added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewText('');
      fetchLawyersTexts();
    } catch (error) {
      setAddError('Please enter text to add.');
      console.error('Error adding lawyer text:', error);
    }
  };

  const updateLawyerImage = async (id) => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.put(`https://back.zubilaw.com/SliderLawyer/updateImage/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setUpdateSuccessMessage('Lawyer image updated successfully!');
      setEditingImageLawyer(null);
      setNewImage(null);
      fetchLawyersImages();
    } catch (error) {
      setUpdateError('Error updating lawyer image.');
      console.error('Error updating lawyer image:', error);
    }
  };

  const updateLawyerText = async (id) => {
    const data = {
      text: newText,
    };

    try {
      await axios.put(`https://back.zubilaw.com/SliderLawyer/updateText/${id}`, data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setUpdateSuccessMessage('Lawyer text updated successfully!');
      setEditingTextLawyer(null);
      setNewText('');
      fetchLawyersTexts();
    } catch (error) {
      setUpdateError('Error updating lawyer text.');
      console.error('Error updating lawyer text:', error);
    }
  };

  const deleteLawyer = (id) => {
    setLawyerToDelete(id);
    setShowDeletePopup(true);
  };

  const performDelete = async () => {
    try {
      await axios.delete(`https://back.zubilaw.com/SliderLawyer/delete/${lawyerToDelete}`);
      setShowDeletePopup(false);
      fetchLawyersImages();
      fetchLawyersTexts();
    } catch (error) {
      console.error('Error deleting lawyer:', error);
    }
  };

  const closeUpdateForm = () => {
    setEditingImageLawyer(null);
    setEditingTextLawyer(null);
    setNewImage(null);
    setNewText('');
  };


  const modules = {
    toolbar: [
      [{ 'color': [] }, { 'background': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': '1' }, { 'header': '2' }, { 'header': [3, 4, 5, 6] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['clean']                                         
    ],
  };
  
  const formats = [
    'background', 'color', 'bold', 'italic', 'underline', 'strike', 'header',
    'list', 'bullet', 'align', 'link', 'image', 'video'
  ];

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Manage Lawyer Images</CardTitle>
            </CardHeader>
            <CardBody>
              <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label>Image</label>
                      <Input
                        type="file"
                        onChange={(e) => setNewImage(e.target.files[0])}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button
                      className="btn-round"
                      color="primary"
                      onClick={addLawyerImage}
                    >
                      Add Lawyer Image
                    </Button>
                    {addSuccessMessage && (
                      <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                        {addSuccessMessage}
                      </div>
                    )}
                    {addError && (
                      <div style={{ color: "red", marginTop: "5px" }} role="alert">
                        {addError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form>
              <Table responsive>
  <thead className="text-primary">
    <tr>
      <th>Image</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {imageLawyers.map((lawyer, index) => (
      <tr key={lawyer.id}>
        <td>
          <img
            src={`https://back.zubilaw.com/${lawyer.slider}`}
            alt="Lawyer Slider"
            style={{ maxWidth: '300px', maxHeight: '200px' }}
          />
        </td>
        <td>
          <Button
            color="success"
            onClick={() => {
              setEditingImageLawyer(lawyer);
              setNewImage(null);
            }}
          >
            Update Image
          </Button>{" "}
          {index !== 0 && (
            <Button
              color="danger"
              onClick={() => deleteLawyer(lawyer.id)}
            >
              Delete
            </Button>
          )}
        </td>
      </tr>
    ))}
  </tbody>
</Table>

            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Text Details</CardTitle>
            </CardHeader>
            <CardBody>
              {/* <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label>Text</label>
                      <Input
                        type="text"
                        value={newText}
                        onChange={(e) => setNewText(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button
                      className="btn-round"
                      color="primary"
                      onClick={addLawyerText}
                    >
                      Add Lawyer Text
                    </Button>
                    {addSuccessMessage && (
                      <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                        {addSuccessMessage}
                      </div>
                    )}
                    {addError && (
                      <div style={{ color: "red", marginTop: "5px" }} role="alert">
                        {addError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form> */}
              <Table responsive>
                <thead className="text-primary">
                  <tr>
                    <th>Text</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {textLawyers.map((lawyer) => (
                    <tr key={lawyer.id}>
                      <td dangerouslySetInnerHTML={{ __html: lawyer.text }}></td>
                      <td>
                        <Button
                          color="success"
                          onClick={() => {
                            setEditingTextLawyer(lawyer);
                            setNewText(lawyer.text);
                          }}
                        >
                          Update Text
                        </Button>{" "}
                        {/* <Button
                          color="danger"
                          onClick={() => deleteLawyer(lawyer.id)}
                        >
                          Delete
                        </Button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {(editingImageLawyer || editingTextLawyer) && (
        <CardFooter>
          <Form>
            <Row>
              {editingTextLawyer && (
                <Col md="7">
                  <FormGroup>
                    <label>Text</label>
                    <div
    style={{
      height: '300px',
      overflowY: 'auto',
    }}
  >
                      <ReactQuill
                        value={newText}
                        onChange={setNewText}
                        modules={modules} 
  formats={formats}
  style={{ height: '80%', color: 'black' }}
/>

  </div>
                  </FormGroup>
                </Col>
              )}

              {editingImageLawyer && (
                <Col md="6">
                  <FormGroup>
                    <label>Image</label>
                    <Input
                      type="file"
                      onChange={(e) => setNewImage(e.target.files[0])}
                    />
                  </FormGroup>
                </Col>
              )}
              <Col md="12">
                {editingTextLawyer && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateLawyerText(editingTextLawyer.id)}
                  >
                    Update Text
                  </Button>
                )}{" "}
                {editingImageLawyer && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateLawyerImage(editingImageLawyer.id)}
                  >
                    Update Image
                  </Button>
                )}{" "}
                <Button
                  className="btn-round"
                  color="secondary"
                  onClick={closeUpdateForm}
                >
                  Cancel
                </Button>
                {updateSuccessMessage && (
                  <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateSuccessMessage}
                  </div>
                )}
                {updateError && (
                  <div className="alert alert-danger" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateError}
                  </div>
                )}
                {imageErrorUpdate && (
                  <div style={{ color: 'red' }}>
                    {imageErrorUpdate}
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </CardFooter>
      )}

      <Modal isOpen={showDeletePopup} toggle={() => setShowDeletePopup(false)}>
        <ModalHeader toggle={() => setShowDeletePopup(false)}>Delete Lawyer</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this lawyer?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={performDelete}>Delete</Button>
          <Button color="secondary" onClick={() => setShowDeletePopup(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SliderLawyersCMS;
